export const PROJECT_EXPENSES_KEY = 'ProjectExpenses';
export const PROJECT_EXPENSES_BASE_PATH = '/expense/project';
